export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20deep%20red%20lighting%2C%20abstract%20film%20reel%20texture%20on%20the%20side%2C%20soft%20bokeh%20lights%2C%20dramatic%20theater%20curtain%20ambiance%2C%20rich%20dark%20background%20with%20subtle%20gradient%2C%20movie%20projector%20light%20rays%2C%20cinematic%20moody%20photography%2C%20high%20contrast%2C%20warm%20tone%20accents&width=1800&height=900&seq=hero-cinema-97&orientation=landscape"
          alt="97影院电影背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-16 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 text-accent-600 text-xs font-medium tracking-wide mb-5">
              <i className="ri-fire-fill text-sm"></i>
              高清蓝光 · 流畅不卡顿
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-black text-white leading-tight mb-4">
              97影院 —<br className="sm:hidden" /> 电影大全免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-white/70 font-heading tracking-wide mb-6">
              最新热播电影、经典电影一站畅享
            </p>

            <p className="text-sm md:text-base text-white/55 leading-relaxed max-w-lg lg:max-w-none mb-8">
              97影院汇聚海量电影资源，涵盖最新热播大片、经典高分影片，覆盖动作、喜剧、科幻、悬疑等多种类型。
              每日持续更新片库，高清蓝光画质搭配流畅播放体验，让您随时随地免费畅享极致观影。
              无论是热门新片还是冷门佳作，在这里都能找到属于您的电影时刻。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-film-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium">每日更新 50+ 部</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-database-2-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium">收录 10 万+ 影片</span>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <i className="ri-4k-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium">高清蓝光画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white/10 backdrop-blur-sm text-white border border-white/20 font-medium text-sm hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20movie%20poster%20collage%20style%2C%20dramatic%20film%20scenes%20montage%20with%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20action%20and%20drama%20film%20reel%20aesthetic%2C%20vintage%20theater%20vibe%20mixed%20with%20modern%20streaming%20feel%2C%20soft%20dramatic%20lighting%2C%20cinematic%20composition%2C%20movie%20projector%20glow%2C%20high%20detail%20photography&width=900&height=1200&seq=hero-poster-97&orientation=portrait"
                alt="97影院 电影大全 在线观影"
                className="w-full h-auto aspect-[3/4] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-black text-xs font-bold">
                  海量片库 免费观看
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}